/**
 * RTK Query API for the Sales Tax switch (Tyler, 2026-10-21): whether an
 * admin has sales tax on. Off, checkout charges none, and web hides the Tax
 * Compliance page and the Sales Tax on Rentals guide with every way into
 * them (useSalesTaxEnabled, salesTaxLoaders).
 *
 * Public, so the guide asks it for a signed-out visitor too. Web never
 * changes the switch, so nothing here marks it stale: RTK Query keeps the
 * answer while any page reads it (the header's menu, on every page), and a
 * visit after an admin's change reads it fresh.
 */
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  SALES_TAX_ROUTES,
  SalesTaxSwitchEnvelopeSchema,
  SalesTaxSwitchSchema,
  unwrapSalesTaxSwitch,
  type SalesTaxSwitch,
} from "@gearghost/api-schemas/salesTax";
import axiosBaseQuery from "./axiosBaseQuery";
import { onSchemaFailure } from "./onSchemaFailure";

export const salesTaxApi = createApi({
  reducerPath: "salesTaxApi",
  baseQuery: axiosBaseQuery(),
  onSchemaFailure,
  endpoints: (builder) => ({
    getSalesTaxSwitch: builder.query<SalesTaxSwitch, void>({
      query: () => SALES_TAX_ROUTES.switch,
      rawResponseSchema: SalesTaxSwitchEnvelopeSchema,
      transformResponse: unwrapSalesTaxSwitch,
      responseSchema: SalesTaxSwitchSchema,
    }),
  }),
});

export const { useGetSalesTaxSwitchQuery } = salesTaxApi;
